import { useStandardProposalTracked } from "presentation/store/StandardProposal/StandardProposalProvider";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import CopyPreviewPanel from "./CopyPreviewPanel";
import ProposalCopyTariffItemTierEditPanel from "./ProposalCopyTariffItemTierEditPanel";

const ProposalCopyingEditRightPanel = () => {
    const [standardProposalState] = useStandardProposalTracked();
    const { isShowCopyEditTierPanel } = standardProposalState;

    return <>
        <div className={`main-comp-wrapper${(isShowCopyEditTierPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={isShowCopyEditTierPanel ? "25%" : "100%"}
                rightSectionWidth={isShowCopyEditTierPanel ? "75%" : "0%"}
                leftChildren={<CopyPreviewPanel />}
                rightChildren={<ProposalCopyTariffItemTierEditPanel />}
            />
        </div>
    </>
}

export default ProposalCopyingEditRightPanel;
